import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";


const GoogleMap = {
  map: null,
  library: null,

  renderer: {
    render: function ({ count, position }, stats) {
      // create svg url with fill color
      const svg = window.btoa(`
			<svg fill="#242538" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
			  <circle cx="120" cy="120" opacity=".6" r="70" />
			  <circle cx="120" cy="120" opacity=".3" r="90" />
			  <circle cx="120" cy="120" opacity=".2" r="110" />
			</svg>`);
      // create marker using svg icon
      return new google.maps.Marker({
        position,
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(50, 50),
        },
        label: {
          text: String(count),
          color: "#fff",
          fontSize: "12px",
        },
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  },

  /**
   * Create google map
   */
  create(data, mapEl) {
    if (!GoogleMap.library) {
      const loader = new Loader({
        apiKey: google_api_key,
        version: "weekly",
        mapId: 'DEMO_MAP_ID'
      });

      loader.load().then((google) => {
        GoogleMap.library = google.maps;
        GoogleMap.createMap(data, mapEl, google);
      });
    } else {
      GoogleMap.createMap(data, mapEl);
    }
  },



  createMap(data, mapEl) {
    const pos = {
      lat: data.lat,
      lng: data.lng,
    };

    const map_options = {
      zoom: data.zoom,
      center: pos,
      disableDefaultUI: true,
      zoomControl: true,
      styles: GoogleMap.styles,
    };

    GoogleMap.map = new GoogleMap.library.Map(mapEl[0], map_options);

    GoogleMap.map.markers = [];

    // Add markers from store items
    const storeItems = document.querySelectorAll('.store-item');
    storeItems.forEach((storeItem) => {
      const markerPosition = {
        lat: parseFloat(storeItem.dataset.lat),
        lng: parseFloat(storeItem.dataset.lng),
      };

      const marker = GoogleMap.addMarker(markerPosition, GoogleMap.map);
      GoogleMap.map.markers.push(marker);

      storeItem.querySelector(".store-item__top-block").addEventListener('click', () => {
        // Find the corresponding marker and zoom the map to its position
        GoogleMap.map.setCenter(marker.getPosition());
        GoogleMap.map.setZoom(14);

        if (storeItem.classList.contains('active')) {
          storeItem.classList.remove('active');
        } else {
          document.querySelectorAll('.store-item.active').forEach((item) => {
            item.classList.remove('active');
          });
          storeItem.classList.add('active');
        }
      });
    });

    let markers = GoogleMap.map.markers;

    // Add a marker clusterer to manage the markers.
    new MarkerClusterer({
      renderer: GoogleMap.renderer,
      map: GoogleMap.map,
      markers,
    });
  },


  /**
   * Create map marker
   */

  addMarker(position, map, storeItem) {

    const icon = {
      url:
        window.location.origin +
        "/themes/base/resources/src/img/gg-map-pin.svg",
      size: new GoogleMap.library.Size(33, 47),
    };

    // Marker options
    const marker_options = {
      position,
      optimized: false,
      map,
      icon,
      animation: GoogleMap.library.Animation.DROP,
    };

    const marker = new GoogleMap.library.Marker(marker_options);

    // Add click event listener to marker
    marker.addListener('click', () => {
      // Find the corresponding store item
      const markerPosition = marker.getPosition();
      map.setCenter(marker.getPosition());
      map.setZoom(14);
      const storeItem = document.querySelector(`.store-item[data-lat="${markerPosition.lat()}"][data-lng="${markerPosition.lng()}"]`);

      if (storeItem) {
        document.querySelectorAll('.store-item.active').forEach((item) => {
          item.classList.remove('active');
        });
        storeItem.classList.add('active');
      }
    });

    return marker;
  },




  styles: [
    {
      "featureType": "administrative",
      "elementType": "all",
      "stylers": [
        {
          "saturation": "-100"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 65
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": "50"
        },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": "-100"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "all",
      "stylers": [
        {
          "lightness": "30"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "all",
      "stylers": [
        {
          "lightness": "40"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "hue": "#ffff00"
        },
        {
          "lightness": -25
        },
        {
          "saturation": -97
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels",
      "stylers": [
        {
          "lightness": -25
        },
        {
          "saturation": -100
        }
      ]
    }
  ],
};

export default GoogleMap;
